<template>
  <div class="listBox">
    <ul class="sBox">
      <li
        style="display: flex; align-items: center"
        v-if="
          $store.state.loginUser?.IsAdmin ||
          $store.state.loginUser?.Qxs?.includes('B_MenPiao_List_添加')
        "
      >
        <el-button
          type="primary"
          icon="Plus"
          link
          @click="
            delete state.selectId;
            state.showCompile = true;
          "
        >
          添加套餐
        </el-button>
      </li>
    </ul>
    <ul class="tBox">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
      >
        <el-table-column
          label="#"
          width="50"
          type="index"
          align="center"
        />
        <el-table-column
          prop="Mc"
          label="套餐名称"
          min-width="150"
        />
        <el-table-column
          prop="Dw"
          label="单位"
          width="80"
          align="center"
        />
        <el-table-column
          prop="Sykc"
          label="剩余库存"
          width="100"
          align="center"
          :formatter="$tab_NumberFormat"
        />
        <el-table-column
          prop="Sm"
          label="说明"
          min-width="200"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="操作"
          width="180"
          align="center"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              :icon="Edit"
              link
              @click="
                state.selectId = row.Id;
                state.showCompile = true;
              "
              v-if="
                $store.state.loginUser?.IsAdmin ||
                $store.state.loginUser?.Qxs?.includes('B_MenPiao_List_编辑')
              "
              >编辑
            </el-button>
            <el-button
              type="danger"
              :icon="Delete"
              link
              @click="onDelete(row.Id)"
              v-if="
                $store.state.loginUser?.IsAdmin ||
                $store.state.loginUser?.Qxs?.includes('B_MenPiao_List_删除')
              "
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showCompile"
        :title="(state.selectId ? '修改' : '添加') + '套餐'"
        @close="state.showCompile = false"
      >
        <c_MenPiaoTcCompile
          @close="
            state.showCompile = false;
            onLoad();
          "
          :id="state.selectId"
          :spId="spId"
        ></c_MenPiaoTcCompile>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { menpiao_tc_list, menpiao_tc_delete } from "@/http/api";
import { confirm_func } from "@/util/tFormat";

export default {
  props: {
    spId: Number,
  },
  setup(props) {
    const state = reactive({
      tableData: [],
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      if (props.spId) {
        delete state.tableData;
        menpiao_tc_list(props.spId).then((res) => {
          if (res.status == 200) {
            state.tableData = res.data;
          }
        });
      }
    };

    //删除
    const onDelete = (id) => {
      confirm_func(menpiao_tc_delete, id, onLoad);
    };

    return {
      state,
      onLoad,
      onDelete,
    };
  },
};
</script>
<style scoped></style>